(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"));
	else if(typeof define === 'function' && define.amd)
		define("eko-flobx", ["mobx"], factory);
	else if(typeof exports === 'object')
		exports["eko-flobx"] = factory(require("mobx"));
	else
		root["eko-flobx"] = factory(root["mobx"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__7__) {
return 